import {GridBasis} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridBasis';
import {GridCellKind} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridCellKind';
import {ColumnKey, IGridCell, IGridHeaderCell} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {FrameField} from '@mintdata/mint-kit/api/values/frames/FrameField';
import bind from 'bind-decorator';

export class FrameColumnHeaderCell implements IGridHeaderCell
{
    private constructor(public readonly columnName:string,
                        public readonly type:Type,
                        public readonly basis:GridBasis)
    {}

    getKind():GridCellKind
    {
        return GridCellKind.FrameColumnHeader;
    }

    @bind
    getBasis(): GridBasis
    {
        return this.basis;
    }

    @bind
    isEqualTo(other:IGridCell):boolean
    {
        return  other &&
                other.getKind() === GridCellKind.FrameColumnHeader &&
                (other as FrameColumnHeaderCell).type.isEqualTo(this.type);
    }

    toString():string
    {
        return `${this.columnName} (${this.type})`;
    }

    public static fromField(field:FrameField):FrameColumnHeaderCell
    {
        return new FrameColumnHeaderCell(field.name, field.type, GridBasis.stretch(1));
    }

    public static fromFieldWithKey(columnKey:ColumnKey, field:FrameField):FrameColumnHeaderCell
    {
        return new FrameColumnHeaderCell(columnKey, field.type, GridBasis.stretch(1));
    }

    public static forFrameMeta(columnKey:ColumnKey):FrameColumnHeaderCell
    {
        return new FrameColumnHeaderCell(columnKey, Type.String, GridBasis.stretch(1));
    }
}
